import React from 'react';

const Toast = ({ show, message }) => {
  return (
    <div className={`toast ${show ? 'active' : ''}`}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="16" x2="12" y2="12"/>
        <line x1="12" y1="8" x2="12.01" y2="8"/>
      </svg>
      <span>{message}</span>
    </div>
  );
};

export default Toast;

